import useIsMobile from '@/hooks/useIsMobile';
import CategoryDesktop from './desktop';
import CategoryMobile from './mobile';
import useCategory from './useCategory';

const ProductCategory = () => {
  const isMobile = useIsMobile(992);
  const viewModel = useCategory();

  if (isMobile) {
    return <CategoryMobile viewModel={viewModel} />;
  }

  return <CategoryDesktop viewModel={viewModel} />;
};

export default ProductCategory;
